import { capitalize } from "@mui/material";
import { BubbleText } from "@totalenergiescode/mobility-business-rev-design-system";
import type { TFunction } from "i18next";

import { RolesProfileIcon } from "@/components/shared/RolesProfileIcon/component";
import { isRolesProfileCode } from "@/components/shared/RolesProfileIcon/types";
import type { ProfileType } from "@/types/profile.ts";

import { getUserRoleDisplayedName } from "./helpers";
import { StyledCellDiv, StyledCellText, StyledIconArrowRight } from "./styles";
import type { FromUserCompaniesToRowsParams, TableColumns, TableRows } from "./types";

export const fromUserCompaniesToColumns = ({
  tUsers,
}: {
  tUsers: TFunction;
}): TableColumns => [
  {
    identifier: "accountNumber",
    columnName: tUsers("users.list.data.accountNumber"),
    displayedByDefault: true,
  },
  {
    identifier: "companyName",
    columnName: tUsers("users.list.data.companyName"),
    displayedByDefault: true,
  },
  {
    identifier: "accountProfile",
    columnName: tUsers("users.list.data.accountProfile"),
    displayedByDefault: true,
  },
  {
    identifier: "status",
    columnName: tUsers("users.list.data.status"),
    displayedByDefault: true,
  },
  {
    identifier: "createdTs",
    columnName: tUsers("users.list.data.createdTs"),
    displayedByDefault: true,
  },
  {
    identifier: "lastConnection",
    columnName: tUsers("users.list.data.lastConnection"),
    displayedByDefault: true,
  },
  {
    identifier: "action",
    columnName: "",
    displayedByDefault: true,
  },
];

export const fromUserCompaniesToRows = ({
  userCompanies,
  selectedIds,
  onNavigate,
  formattedDate,
  tCompanies,
  tProfiles,
}: FromUserCompaniesToRowsParams): TableRows =>
  userCompanies.map((company) => ({
    id: company.id,
    key: company.id,
    selected: selectedIds.has(company.id),
    onRowClick: () => onNavigate(company.accountId),
    data: {
      accountNumber: company.accountNumber,
      companyName: company.accountName,
      accountProfile: (
        <StyledCellDiv>
          {isRolesProfileCode(company?.subscriptions?.[0]?.roleCode ?? "") ? (
            <RolesProfileIcon
              code={
                (company?.subscriptions?.[0]?.roleCode as ProfileType) ?? ""
              }
              size={28}
            />
          ) : null}
          <StyledCellText variant='text2'>
            {getUserRoleDisplayedName({
              code: company?.subscriptions?.[0]?.roleCode,
              name: company?.subscriptions?.[0]?.roleName,
              t: tProfiles,
            })}
          </StyledCellText>
        </StyledCellDiv>
      ),
      status: (
        <BubbleText
          text={capitalize(
            tCompanies(
              `companies.list.status.${company.status}.label`.toLowerCase(),
            ),
          )}
          variant={company.status.toLowerCase() === "active" ? "green" : "grey"}
        />
      ),
      createdTs: formattedDate(company.invitedTs),
      lastConnection: formattedDate(company?.lastUsedTs),
      action: <StyledIconArrowRight />,
    },
  }));
